// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","cls1":"_39GZA","cls3":"_2Ol4k","cls2":"_1udA2"};